<template>
  <div class="container">
    <div class="app">
      <div v-for="item in photos" :key="item.name" class="project-item">
        <h2>{{ item.name }}</h2>
        <div class="images" :class="{'images-col2': item.col===2, 'images-col3': item.col===undefined}">
          <img v-for="url in item.urls" :key="url" v-lazy="'//public-file.jethro.fun/resume/' + url" alt=""
               @click="showBig(item, url)"/>
        </div>
      </div>

      <div id="images-dialog">
        <img v-for="url in bigImages" :src="'//public-file.jethro.fun/resume/' + url" :key="url" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'

export default {
  name: 'SamplePhoto',
  data () {
    return {
      bigImages: [],
      photos: [
        {
          name: '维普职考在线APP-flutter',
          urls: [
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/chats.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/message.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/cloud.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/cloud2.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/course.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/do-exam.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-anlsis3.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-anysis.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-anysis2.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-anysisy.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-card.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-end.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/exam-list.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/home.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/members.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/result-anysis.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/start-exam.jpg',
            '%E7%BB%B4%E6%99%AE%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFAPP/user-home.jpg'
          ]
        },
        {
          name: '维普职考在线WEB-NUXT.js',
          urls: [
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/ani.gif',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/course-exam.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/course.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/course2.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/exam-list.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/exam.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/exam2.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/help.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/home.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/pay.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/result-anysis.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/studen.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/tea.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/view-exam.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/view-exam2.png',
            '%E8%81%8C%E8%80%83%E5%9C%A8%E7%BA%BFWEB/view-exam3.png'
          ]
        },
        {
          name: '热点APP-flutter',
          urls: [
            '%E7%83%AD%E7%82%B9APP/webview%E5%86%85%E5%B5%8C.jpg',
            '%E7%83%AD%E7%82%B9APP/%E4%B8%AA%E4%BA%BA%E9%A1%B5%E9%9D%A2.jpg',
            '%E7%83%AD%E7%82%B9APP/%E5%85%A8%E7%BD%91%E7%83%AD%E7%82%B9%E7%AE%80%E6%8A%A5.jpg',
            '%E7%83%AD%E7%82%B9APP/%E5%BE%AE%E5%8D%9A%E7%83%AD%E7%82%B9.jpg',
            '%E7%83%AD%E7%82%B9APP/%E6%84%8F%E8%A7%81%E5%8F%8D%E9%A6%88%E9%A1%B5%E9%9D%A2.jpg',
            '%E7%83%AD%E7%82%B9APP/%E6%90%9C%E7%B4%A2%E9%A1%B5.jpg',
            '%E7%83%AD%E7%82%B9APP/%E7%99%BE%E5%BA%A6%E7%BD%91%E9%A1%B5%E5%86%85%E5%B5%8C.jpg',
            '%E7%83%AD%E7%82%B9APP/%E7%9F%A5%E4%B9%8E%E6%A6%9C%E5%8D%95.jpg',
            '%E7%83%AD%E7%82%B9APP/%E7%9F%A5%E4%B9%8E%E8%AF%A6%E6%83%85.jpg',
            '%E7%83%AD%E7%82%B9APP/%E8%A7%86%E9%A2%91%E6%92%AD%E6%94%BE%E9%A1%B5%E9%9D%A2.jpg',
            '%E7%83%AD%E7%82%B9APP/%E8%AF%9D%E9%A2%98%E5%85%B3%E6%B3%A8%E9%A1%B5%E9%9D%A2.jpg',
            '%E7%83%AD%E7%82%B9APP/%E8%AF%9D%E9%A2%98%E9%A1%B5.jpg',
            '%E7%83%AD%E7%82%B9APP/%E9%A6%96%E9%A1%B5.jpg'
          ]
        },
        {
          name: '8点情报-钉钉小程序',
          urls: [
            '8%E7%82%B9%E6%83%85%E6%8A%A5/24%E5%B0%8F%E6%97%B6%E7%AE%80%E6%8A%A5.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E4%BB%98%E8%B4%B9%E6%9C%8D%E5%8A%A1.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E6%84%8F%E8%A7%81%E5%8F%8D%E9%A6%88.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E6%88%91%E7%9A%84.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E7%AE%80%E6%8A%A5%E5%AE%9A%E5%88%B6-%E5%8F%B3%E6%BB%91%E5%88%A0%E9%99%A4.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E7%AE%80%E6%8A%A5%E5%AE%9A%E5%88%B6.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E7%AE%80%E6%8A%A5%E8%AF%A6%E6%83%85.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E8%87%AA%E5%AE%9A%E4%B9%89%E6%A8%A1%E5%9D%97.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E9%80%89%E6%8B%A9%E5%85%B3%E9%94%AE%E5%AD%97.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E9%80%89%E6%8B%A9%E6%A8%A1%E5%9D%97.png',
            '8%E7%82%B9%E6%83%85%E6%8A%A5/%E9%82%AE%E4%BB%B6.png'
          ]
        },
        {
          name: '蜂集市后台管理-vue',
          urls: [
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/app%E7%89%88%E6%9C%AC%E7%AE%A1%E7%90%86.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E5%86%9C%E5%8E%86%E5%8C%85%E5%88%97%E8%A1%A8-%E5%8F%AF%E6%8B%96%E5%8A%A8%E6%8E%92%E5%BA%8F.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E5%90%8E%E5%8F%B0%E8%8F%9C%E5%8D%95%E7%AE%A1%E7%90%86.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E5%95%86%E5%93%81%E7%BB%9F%E8%AE%A1.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E5%95%86%E5%93%81%E7%BB%9F%E8%AE%A12.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%8E%A8%E9%80%81%E7%AE%A1%E7%90%86.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%94%B6%E5%85%A5%E7%BB%93%E7%AE%97.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%96%87%E7%AB%A0%E7%BC%96%E8%BE%91.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%B4%BB%E5%8A%A8%E7%AE%A1%E7%90%86-%E8%AE%BE%E7%BD%AE%E5%AF%BC%E8%88%AA.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%B4%BB%E5%8A%A8%E7%AE%A1%E7%90%86-%E8%AE%BE%E7%BD%AE%E5%AF%BC%E8%88%AA2.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%B7%BB%E5%8A%A0%E5%95%86%E5%93%81%E7%BB%84%E4%BB%B6.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E6%B7%BB%E5%8A%A0%E5%95%86%E5%93%81%E7%BB%84%E4%BB%B62.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E7%99%BB%E5%BD%95%E7%95%8C%E9%9D%A2.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E8%A7%92%E8%89%B2%E7%AE%A1%E7%90%86-%E8%8F%9C%E5%8D%95%E6%9D%83%E9%99%90%E8%AE%BE%E7%BD%AE.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E8%AE%A2%E5%8D%95%E5%88%97%E8%A1%A8.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E8%AE%A2%E5%8D%95%E5%88%97%E8%A1%A82.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E8%B4%A2%E5%8A%A1%E7%94%B3%E8%AF%B7.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E9%9B%86%E5%B8%82%E8%AF%BE%E5%A0%82%E8%A7%86%E9%A2%91%E7%AE%A1%E7%90%86.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%90%8E%E5%8F%B0/%E9%A6%96%E9%A1%B5%E9%85%8D%E7%BD%AE.png'
          ],
          col: 2
        },
        {
          name: '蜂集市微信端-vue',
          urls: [
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%86%9C%E5%8E%86%E5%8C%85%E8%B4%AD%E7%89%A9%E8%BD%A6.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%86%9C%E7%A4%BC%E5%8C%85%E6%B4%BB%E5%8A%A8%E9%A6%96%E9%A1%B5.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%86%9C%E7%A4%BC%E5%8C%85%E6%B4%BB%E5%8A%A8%E9%A6%96%E9%A1%B52.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%8E%86%E5%8F%B2%E8%B6%B3%E8%BF%B9.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%9C%B0%E5%9D%80%E7%AE%A1%E7%90%86-%E5%88%97%E8%A1%A8.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%9C%B0%E5%9D%80%E7%AE%A1%E7%90%86-%E5%8C%BA%E5%8E%BF%E9%80%89%E6%8B%A9%E5%9B%9E%E9%80%80.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%9C%B0%E5%9D%80%E7%AE%A1%E7%90%86-%E7%BC%96%E8%BE%91%E5%9C%B0%E5%9D%80.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E5%9C%B0%E5%9D%80%E7%AE%A1%E7%90%86-%E9%80%89%E6%8B%A9%E5%8C%BA%E5%8E%BF.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E7%93%9C%E5%88%8610%E4%BA%BF%E6%B4%BB%E5%8A%A8-%E6%88%91%E7%9A%84%E7%8E%B0%E9%87%91%E8%A1%A5%E8%B4%B4.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E7%93%9C%E5%88%8610%E4%BA%BF%E6%B4%BB%E5%8A%A8-%E8%A7%84%E5%88%99%E5%BC%B9%E7%AA%97.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E7%93%9C%E5%88%8610%E4%BA%BF%E6%B4%BB%E5%8A%A8-%E8%A7%84%E6%A0%BC%E9%80%89%E6%8B%A9.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E7%93%9C%E5%88%8610%E4%BA%BF%E6%B4%BB%E5%8A%A8-%E9%A6%96%E9%A1%B5.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E8%AE%A2%E5%8D%95%E5%88%97%E8%A1%A8.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E8%AE%A2%E5%8D%95%E7%BB%93%E7%AE%97.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E9%9B%86%E5%B8%82%E8%AF%BE%E5%A0%82-%E5%88%97%E8%A1%A8.png',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E9%9B%86%E5%B8%82%E8%AF%BE%E5%A0%82%E8%AF%A6%E6%83%85%E9%A1%B5.jpg',
            '%E8%9C%82%E9%9B%86%E5%B8%82%E5%BE%AE%E4%BF%A1/%E9%A6%96%E9%A1%B5.jpg']
        },
        {
          name: '橙子校园app-flutter',
          urls: [
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E4%BF%AE%E6%94%B9%E6%94%AF%E4%BB%98%E5%AF%86%E7%A0%81-%E8%87%AA%E5%AE%9A%E4%B9%89%E9%94%AE%E7%9B%98.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E5%9C%B0%E5%9D%80%E9%80%89%E6%8B%A9%E5%99%A8-%E5%AD%A6%E6%A0%A1.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E5%9C%B0%E5%9D%80%E9%80%89%E6%8B%A9%E5%99%A8-%E5%B8%82.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E5%9C%B0%E5%9D%80%E9%80%89%E6%8B%A9%E5%99%A8%E7%9C%81.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E5%BA%97%E9%93%BA-%E5%95%86%E5%93%81%E5%88%97%E8%A1%A8.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E5%BA%97%E9%93%BA-%E8%AF%84%E4%BB%B7.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E5%BA%97%E9%93%BA%E5%BD%92%E7%B1%BB.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E8%B5%84%E6%96%99%E4%BF%AE%E6%94%B9.jpg',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD/%E9%A6%96%E9%A1%B5.jpg'
          ]
        },
        {
          name: '橙子校园后台管理',
          urls: [
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD%E5%90%8E%E5%8F%B0/app%E5%8D%87%E7%BA%A7-%E5%86%85%E5%B5%8Cvue.png',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD%E5%90%8E%E5%8F%B0/app%E5%8D%87%E7%BA%A7.png',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD%E5%90%8E%E5%8F%B0/%E7%94%A8%E6%88%B7%E5%88%97%E8%A1%A8.png',
            '%E6%A9%99%E5%AD%90%E6%A0%A1%E5%9B%AD%E5%90%8E%E5%8F%B0/%E9%A6%96%E9%A1%B5.png'
          ],
          col: 2
        }
      ]
    }
  },
  methods: {
    showBig (photoItem, url) {
      this.bigImages = photoItem.urls
      this.$nextTick(() => {
        if (this.viewer == null) {
          this.viewer = new Viewer(document.getElementById('images-dialog'), {
            navbar: 2,
            toolbar: {
              zoomIn: {
                size: 'large',
                show: true
              },
              zoomOut: {
                size: 'large',
                show: true
              },
              prev: {
                size: 'large',
                show: true
              },
              next: {
                size: 'large',
                show: true
              },
              rotateLeft: {
                size: 'large',
                show: true
              },
              rotateRight: {
                size: 'large',
                show: true
              }
            }
          })
        } else {
          this.viewer.update()
        }
        const index = this.bigImages.indexOf(url)
        this.viewer.view(index)
      })
    }
  },
  destroyed () {
    if (this.viewer) {
      this.viewer.destroy()
    }
  }
}
</script>

<style scoped lang="less">

@import "../common";

.project-item {
  padding: @padding2x @padding4x;

  .images-col2 {
    grid-template-columns: 1fr 1fr;
  }

  .images-col3 {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .images {
    display: grid;
    gap: @padding;

    img {
      width: 100%;
      height: auto;
      transition: transform .3s;
    }

    @media screen and (min-width: 750px) {
      img:hover {
        position: relative;
        cursor: zoom-in;
        transform: scale(1.26, 1.26);
        box-shadow: 6px 6px 10px rgba(0, 0, 0, 0.08);
        z-index: 60;
      }
    }
  }
}

#images-dialog {
  display: none;
}
</style>
